/**
 * A test's name as a teacher picks it in Ödev Oluştur (CreateAssignmentModal).
 *
 * This file used to hold the test picker of the goal forms' "Kitap ödevi de
 * oluştur" option; that option was removed (2026-10) and only the name helper
 * is still used.
 *
 * ⚠️ A test is picked by its id on new-model books. A konu's tests can share one
 * title, so the name is numbered when its konu repeats it.
 */

/** The test's name as a teacher picks it: the student's caption, numbered when its konu repeats it. */
export const testNameOf = (s: { section_label: string; section_display_label?: string | null; test_ordinal?: number | null }): string =>
  `${s.section_display_label || s.section_label}${s.test_ordinal ? ` - ${s.test_ordinal}. test` : ''}`;
